import TeamMembers from '../../../views/practice/team-members/TeamMembers'

const teamMembersRoutes = [
  {
    path: '/practice/team-members',
    element: <TeamMembers />
  },
]

export default teamMembersRoutes
